import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';

export interface IAnonymousAccessToken {
  _id: string;
  user: ObjectID;
  lastUsed: Date;
  updatedAt: Date;
  createdAt: Date;
}

export interface IAnonymousAccessTokenDocument extends mongoose.Document, IAnonymousAccessToken {
  _id: string;
}

const schema = new Schema(
  {
    _id: {
      type: String,
      required: true,
    },
    user: {
      type: Schema.Types.ObjectId,
      ref: 'User',
      required: true,
    },
    lastUsed: {
      type: Date,
      default: Date.now,
      required: true,
    },
  },
  { timestamps: true },
);

// we'll only store 1 access token per anonymous user
schema.index({ user: 1 }, { unique: true });

export default schema;
